var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExibitors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 24,
    height: 26,
    fill: "url(#paint0_linear_157_11)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0C0.223858 0 0 0.223858 0 0.5C0 0.776142 0.223858 1 0.5 1H1V25V26H2H9H10H16H17H24H25V25V1H25.5C25.7761 1 26 0.776142 26 0.5C26 0.223858 25.7761 0 25.5 0H25H24H2H1H0.5ZM24 1H2V25H9V17H8.5C8.22386 17 8 16.7761 8 16.5C8 16.2239 8.22386 16 8.5 16H9H10H16H17H17.5C17.7761 16 18 16.2239 18 16.5C18 16.7761 17.7761 17 17.5 17H17V25H24V1ZM16 17H10V25H16V17ZM13 19.441L13.2236 19.8882L14.2236 21.8882L14.3042 22.0494L14.1768 22.1768L13.1768 23.1768L13 23.3536L12.8232 23.1768L11.8232 22.1768L11.6958 22.0494L11.7764 21.8882L12.7764 19.8882L13 19.441ZM12.3042 21.9506L13 22.6464L13.6958 21.9506L13 20.559L12.3042 21.9506Z",
    fill: "#14B4C2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_157_11",
    x1: 13,
    y1: -27.5,
    x2: 13,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14B4C2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExibitors);
export default __webpack_public_path__ + "static/media/icon-exibitors.e3a0aa156b0bc9cbed270dbd88725b77.svg";
export { ForwardRef as ReactComponent };